Revolution.Module.extend({
    NAME: "mde.forms", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        //events
        this.initInputFile();

        $('.label-number').closest('label').prev().on('change', this.checkboxesCounter);
        $('.js-uncheck-options').on('click', this.uncheckOptions);

        $('body').on('change', '.js-conditional-radio', this.conditionnalRadio);

        $('body').on('click', '.js-add-form-line', this.addFormLine);
        $('body').on('click', '.js-remove-line', this.removeFormLine);
        $('body').on('keyup', 'input[id^="all_months"]', this.changeValueMonthsCalculator);


        $('.js-only-numbers').mask('0#');

        this.selectCustom();

        this.initDatepicker();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    removeFormLine: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.js-added-line').remove();
    },

    addFormLine: function (e) {
        var $obj = $(e.currentTarget);
        var $parent = $obj.closest('.js-add-form-line-wrapper');
        var templating = $parent.find('[type="text/template"]').html();
        var $wrapper = $parent.find('.js-insert-wrapper');
        var nblines = $wrapper.find('> *').length;
        var renderTemplate = templating.replace(/{i}/g, nblines + 1);

        $wrapper.append(renderTemplate);
        $.applyDataMask();
        Revolution.get("mde.accessible-function").giveTempFocus($wrapper.find('.js-added-line:last-child'));
    },

    conditionnalRadio: function (e) {
        var $obj = $(e.currentTarget);
        var group = $obj.data('fields-group');
        var targets = $obj.data('fields');
        var targetsArray = targets.split(', ');

        $(group).find('.js-conditional').hide();
        $(group).find('.js-conditional').find('[data-required]').removeAttr('required');

        for(i=0; i < targetsArray.length; i++) {
            var target = targetsArray[i];
            $(target).show();
            $(target).find('[data-required]').attr('required', true);
        }
    },

    initInputFile: function () {
        $('.js-inputfile').each(function (index, el) {
            $(el).on('change', function (e) {
                console.log(this.files.length);
                if (this.files.length >= 1) {
                    $(el).closest('.custom-js-inputfile').addClass('js-has-file');
                } else {
                    $(el).closest('.custom-js-inputfile').removeClass('js-has-file');
                }
            });
        });
    },
    clearInputFile : function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('label').prev('[type="file"]').val('');
        $obj.closest('label').find('.result').text('');
        $obj.hide();
    },

    checkboxesCounter: function(e) {

        var $obj = $(e.currentTarget);
        var $label = $(e.currentTarget).next('label');
        var $parent = $obj.closest('.bk-options');
        var nbChecked = $parent.find(':checked').length;

        if (nbChecked > 0) {
            $parent.next('.ta-c').find(':checked').prop('checked', false);
        }

        if ($obj.is(':checked')) {
            $label.find('.label-number').html(nbChecked);
        } else {
            var valDisable = parseInt($label.find('.label-number').html());
            $parent.find(':checked').each(function(index, elem) {
                var val = parseInt($(elem).next('label').find('.label-number').html());
                if (val > valDisable) {
                    $(elem).next('label').find('.label-number').html(val - 1);
                }
            });
        }
    },

    uncheckOptions: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.ta-c').prev('.bk-options').find(':checked').prop('checked', false);
    },

    selectCustom: function() {
        $('.wrapper-select2 select').select2({
            minimumResultsForSearch: -1,
            width: '100%'
        });

        $('.wrapper-select2 select').on('select2:open', function (e) {
            console.log('open');
            console.log($(this));
            $(".select2-results").overlayScrollbars({});
          });
    },

    initDatepicker: function() {
        var dayMinEn = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ];
        var dayMinFr = [ "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam" ];
        var monthMinEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var monthMinFr = ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun", "Jul", "Aou", "Sep", "Oct", "Nov", "Dec"];
        $('.js-custom-datepicker').each(function (index, el) {
            $(el).datepicker({
                dayNamesMin : $('html').attr('lang') == 'fr' ? dayMinFr : dayMinEn,
                monthNamesShort: $('html').attr('lang') == 'fr' ? monthMinFr : monthMinEn,
                firstDay: $('html').attr('lang') == 'fr' ? 1 : 0,
                dateFormat: $('html').attr('lang') == 'fr' ? "dd/mm/yy" : "mm/dd/yy",
                changeMonth: true,
                changeYear: true,
                showOtherMonths: true,
                selectOtherMonths: true,
                yearRange: "-100:+0",
            });

            if($(el).attr('id') == 'edit-retirement-date') { //retraite
                $(el).datepicker( "option", "yearRange", "-10:+40");
            }
        });
    },

    changeValueMonthsCalculator: function(e) {
        var $obj = $(e.currentTarget);
        var value = $obj.val();
        $obj.closest('.years-block').find('input').val(value);
    }
});
